(function () {
  var KEY = 'as:collection-view';
  var root = document.documentElement;

  function sync(view) {
    var btns = document.querySelectorAll('[data-view-set]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', String(btns[i].dataset.viewSet === view));
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-view-set]');
    if (!btn) return;
    var view = btn.dataset.viewSet;
    root.setAttribute('data-view', view);
    try { localStorage.setItem(KEY, view); } catch (err) {}
    sync(view);
  });

  new MutationObserver(function () {
    sync(root.getAttribute('data-view') || 'grid');
  }).observe(document.body, { childList: true, subtree: true });

  sync(root.getAttribute('data-view') || 'grid');
})();